import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, browserPopupRedirectResolver } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLxVU0_maGd0ABdnWgJrnTyui8K1WjRHc",
  authDomain: "game-pre-battle.firebaseapp.com",
  databaseURL: "https://game-pre-battle-default-rtdb.firebaseio.com",
  projectId: "game-pre-battle",
  storageBucket: "game-pre-battle.firebasestorage.app",
  messagingSenderId: "216467839161",
  appId: "1:216467839161:web:c21cec40f3bbb08171a368",
  measurementId: "G-6PFPD7B245"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
// Configure auth for better popup handling
auth.useDeviceLanguage();

// The following code is commented out to use production Firebase instead of the emulator
// If you need to use the emulator again for testing, uncomment this block
/*
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  connectAuthEmulator(auth, "http://localhost:9099");
}
*/

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

// Export the popup resolver to be used in auth methods
export const popupRedirectResolver = browserPopupRedirectResolver;

export default app; 